export default __webpack_public_path__ + "static/media/background.9ebf8d81.png";